// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import {router} from './router'
import 'iview/dist/styles/iview.css'
import './common/style/index.less'
import './common/style/flexable.less'
import iView from 'iview'
import Ajax from './ajax/index'

Vue.use(iView)
Vue.prototype.$ajax = Ajax
Vue.prototype.$eventHub = Vue.prototype.$eventHub || new Vue()
Vue.prototype.$fileUpload = process.env.serverHost + '/wtuploader/controller?action=uploads&method=country-img'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js